import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription, combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ErrorBannerService } from '../../../core/services/error-banner.service';

@Component({
  selector: 'app-error-banner',
  standalone: false,
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
})
export class ErrorBannerComponent implements OnInit, OnDestroy {
  errors: string[] = [];
  isSuppressed = false;
  private sub?: Subscription;
  private routerSub?: Subscription;

  constructor(
    private errorBannerService: ErrorBannerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.sub = combineLatest([
      this.errorBannerService.errors$,
      this.errorBannerService.suppressed$
    ]).subscribe(([errors, suppressed]) => {
      this.errors = errors;
      this.isSuppressed = suppressed;
    });

    this.routerSub = this.router.events
      .pipe(filter((e) => e instanceof NavigationStart))
      .subscribe(() => {
        this.errorBannerService.clear();
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.routerSub?.unsubscribe();
  }

  dismiss(index: number): void {
    this.errorBannerService.remove(index);
  }
}
